import _ from 'lodash';
import config from '../configs/AppConfigs';
import { UserGroup } from '../configs/types';

export const getUserGroups = (state: any): UserGroup[] => {
  return _.get(state, `${config.moduleName}/userGroup.groups`, []);
};
